import { Grid } from '@mui/material';
import { rem } from '@Utils/styles';
import styled from 'styled-components';

export const NotesWrapper = styled(Grid)`
	padding-left: ${rem(25)};
	background-color: ${({ theme }) => theme.palette.background.paper};
`;
